export const environment = {
  production: true,
  hostName: 'https://mascinemateca.org.uy',
  apiEndpoint: 'https://servicios.mascinemateca.org.uy/api',
  siemprePago_enviroment: 'production',
  siemprePago_publicKey: 'EnBnWeAa45RjPSx-Zr_LM2_I56ONV7HQ',
  siemprePago_captureURL: 'https://api.siemprepago.com/v1/Capture',
  siemprePagoNoCVV_publicKey: 'hMh3WYXqw0XaltouPYbq_W_I56ONV7HQ', //Para suscirpcion
  search_debounce: 2000, //(milisegundos)
  home_scroll_offset: 1500,
  catalogue_page_size: 24
};

// export const environment = {
//   production: true,
//   hostName: 'https://mascinemateca.org.uy',
//   // hostName: 'https://cinemateca.fx2.com.uy',
//   apiEndpoint: 'https://cinemateca.fx2.com.uy:86/api',
//   siemprePago_enviroment: 'testing',
//   siemprePago_publicKey: 'uKQ7wKyJnm77-1meXHCbtW_I56ONV7HQ',
//   siemprePago_captureURL: 'https://testapi.siemprepago.com/v1/Capture',
//   siemprePagoNoCVV_publicKey: 'uKQ7wKyJnm77-1meXHCbtW_I56ONV7HQ',
//   search_debounce: 2000, //(milisegundos)
//   home_scroll_offset: 1500
// };

